import { RevCollectionData } from 'st-app/api';


export class CollectionInfoInstance extends RevCollectionData {
    constructor(coll: RevCollectionData) {
        super();
        Object.assign(this, coll);
    }
}
